import { useState } from 'react'
import { useTrocarPropriaSenha } from '../../api/queries/usuarios'
import { Botao } from '../../components/Botao'
import { AvisoDeErro } from '../../components/Estados'
import { CampoDeTexto } from '../../components/campos'
import { TEXTOS } from '../../lib/glossario'

/**
 * A troca de senha que bloqueia o resto do sistema.
 *
 * Aparece no lugar da aplicação inteira enquanto `deveTrocarSenha` for verdadeiro. Não é um aviso
 * que dá para adiar: a senha foi definida por outra pessoa e chegou por e-mail ou mensagem, então
 * até a troca acontecer quem viu a mensagem entra na conta.
 *
 * A explicação vem antes dos campos, e diz o motivo real — "sua senha veio por um canal que
 * ninguém controla" — em vez do genérico "por segurança, troque sua senha", que ninguém lê.
 *
 * @returns a tela de troca obrigatória
 */
export function TrocaDeSenhaObrigatoria() {
  const trocar = useTrocarPropriaSenha()
  const [senhaAtual, setSenhaAtual] = useState('')
  const [novaSenha, setNovaSenha] = useState('')
  const [confirmacao, setConfirmacao] = useState('')
  const t = TEXTOS.usuarios.trocaObrigatoria

  const naoConfere = confirmacao !== '' && confirmacao !== novaSenha

  async function salvar() {
    if (naoConfere) {
      return
    }
    try {
      await trocar.mutateAsync({ senhaAtual, novaSenha })
    } catch {
      // O AvisoDeErro diz o que o servidor recusou e por quê.
    }
  }

  return (
    <main className="mx-auto flex min-h-screen max-w-lg flex-col justify-center px-4 py-10">
      <div className="cartao space-y-4 p-6">
        <div>
          <h1 className="text-xl font-bold text-slate-900">{t.titulo}</h1>
          <p className="mt-1 max-w-prose text-sm text-slate-600">{t.ajuda}</p>
        </div>

        <CampoDeTexto
          rotulo={t.senhaAtual}
          ajuda={t.senhaAtualAjuda}
          type="password"
          autoComplete="current-password"
          value={senhaAtual}
          onChange={(e) => setSenhaAtual(e.target.value)}
        />
        <CampoDeTexto
          rotulo={t.novaSenha}
          ajuda={t.novaSenhaAjuda}
          type="password"
          autoComplete="new-password"
          value={novaSenha}
          onChange={(e) => setNovaSenha(e.target.value)}
        />
        <CampoDeTexto
          rotulo={t.confirmar}
          erro={naoConfere ? t.naoConfere : undefined}
          type="password"
          autoComplete="new-password"
          value={confirmacao}
          onChange={(e) => setConfirmacao(e.target.value)}
        />

        {trocar.isError && <AvisoDeErro erro={trocar.error} titulo={t.naoTrocou} />}

        <Botao aparencia="primario" onClick={salvar} disabled={trocar.isPending || naoConfere}>
          {trocar.isPending ? 'Salvando…' : t.salvar}
        </Botao>
      </div>
    </main>
  )
}
